import { semiDesignDark } from "./dark";

import { semiDesignLight } from "./light";

import { dataSchemeTokenMap, paletteTokenMap } from "./common/token-map";

import { generateDataScheme, generatePalette } from "@visactor/vchart-theme-utils";

const baseThemeMap = {
    light: semiDesignLight,
    dark: semiDesignDark
};

export const generateVChartSemiTheme = (mode, chartContainer) => {
    const baseTheme = baseThemeMap[mode], {dataScheme: dataScheme, palette: palette} = baseTheme.colorScheme.default, colorScheme = {
        default: {
            dataScheme: generateDataScheme(mode, dataSchemeTokenMap, dataScheme, chartContainer),
            palette: generatePalette(mode, paletteTokenMap, palette, chartContainer)
        }
    };
    return Object.assign(Object.assign({}, baseTheme), {
        colorScheme: colorScheme
    });
};